"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BlCircleRadio = function (props) {
    var onChange = props.onChange, checked = props.checked, label = props.label, name = props.name, _a = props.disabled, disabled = _a === void 0 ? false : _a;
    return (react_1.default.createElement("label", { className: styles_module_scss_1.default.radio_circled_label, htmlFor: name },
        react_1.default.createElement("input", { type: "checkbox", name: name, value: label, onChange: function () { return onChange(label); }, checked: checked, disabled: disabled }),
        react_1.default.createElement("span", null, label)));
};
exports.default = BlCircleRadio;
